import { useState } from 'react';
import cn from 'classnames';
// Types
import {
  GetStream_stream_hashtags,
  GetStream_stream_views,
} from 'api/streams/types/GetStream';
import VideoDetails, {
  VideoDetails as VideoDetailsType,
} from 'components/common3/VideoDetails/VideoDetails';
// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './StreamDescription.module.scss';

type StreamDescriptionProps = {
  description: string | null;
  descriptionPreview: string;
  mobileDescriptionPreview: string;
  streamDateTimeText: string;
  videoDetails: VideoDetailsType;
  hashtags: GetStream_stream_hashtags[];
  views: GetStream_stream_views | null;
  isStreamEnded: boolean;
  onOpenModal: () => void;
  showDisclaimer: boolean;
};

const StreamDescription = ({
  description,
  descriptionPreview,
  mobileDescriptionPreview,
  streamDateTimeText,
  videoDetails,
  hashtags,
  views,
  isStreamEnded,
  onOpenModal,
  showDisclaimer,
}: StreamDescriptionProps) => {
  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);

  if (!description) {
    return null;
  }

  const handleReadMore = () => {
    setIsDetailsExpanded(!isDetailsExpanded);
  };

  return (
    <div
      className={cn(styles.detailsSection, {
        [styles.detailsSectionExpanded]: isDetailsExpanded,
      })}
    >
      {/* Mobile Collapsed View */}
      <div className={styles.mobileCollapsedView}>
        {!isDetailsExpanded && (
          <>
            <div className={styles.viewsDateRow}>
              {isStreamEnded && views?.totalViewCount != null && (
                <span className={styles.viewsText}>
                  <MillionsIcon
                    name="eye"
                    className={styles.eyeIcon}
                    size={16}
                  />
                  {views.totalViewCount} views
                </span>
              )}
              <span className={styles.dateText}>{streamDateTimeText}</span>
            </div>
            <div className={styles.descriptionPreview}>
              {mobileDescriptionPreview}
            </div>
            <button
              type="button"
              onClick={handleReadMore}
              className={styles.readMoreButton}
            >
              Show More
            </button>
          </>
        )}
      </div>

      {/* Mobile Expanded View */}
      <div className={styles.mobileExpandedView}>
        {isDetailsExpanded && (
          <>
            <VideoDetails
              className={styles.videoDetailsUpdated}
              videoDetails={videoDetails}
              streamDateTimeText={streamDateTimeText}
              isStream={true}
              hashtags={hashtags || []}
              startExpanded={true}
              showDisclaimer={showDisclaimer}
            />
            <button
              type="button"
              onClick={handleReadMore}
              className={styles.readMoreButton}
            >
              Show Less
            </button>
          </>
        )}
      </div>

      {/* Desktop View */}
      <div className={styles.desktopView}>
        <div className={styles.descriptionPreview}>{descriptionPreview}</div>
        <button
          type="button"
          onClick={onOpenModal}
          className={styles.readMoreButton}
        >
          Read More
        </button>
      </div>
    </div>
  );
};

export default StreamDescription;
